import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AgreementService } from '../../services/agreement.service';
import { OneClickEnrollComponent } from '../oneClickEnroll/one-click-enroll.component';
import { Inject, Optional } from '@angular/core';
import { LogService } from '@pershing/pershing-core';
import { EdeliveryLabels } from '../../i18n/edelivery-labels';
import { PershingTranslationService } from '@pershing/pershing-core';

@Component({
  selector: 'one-click-enroll-cancel',
  templateUrl: './one-click-enroll-cancel.component.html',
  styleUrls: ['./one-click-enroll-cancel.component.css']
})
export class OneClickEnrollCancelComponent implements OnInit {

  log: LogService;
  // emails: Email[] = [];

  // Labels
  backLabel = EdeliveryLabels.ONE_CLICK_ENROLL_BACK;
  continueLabel = EdeliveryLabels.ONE_CLICK_ENROLL_OK;
  oneClickEnrollCancelHeaderDescription1 = EdeliveryLabels.ONE_CLICK_ENROLL_CANCEL_HEADER_DESCRIPTION_1;
  oneClickEnrollCancelHeaderDescription2 = EdeliveryLabels.ONE_CLICK_ENROLL_CANCEL_HEADER_DESCRIPTION_2;
  oneClickEnrollCancelHeaderDescription3 = EdeliveryLabels.ONE_CLICK_ENROLL_CANCEL_HEADER_DESCRIPTION_3;
  oneClickEnrollCancelHeaderDescription4 = EdeliveryLabels.ONE_CLICK_ENROLL_CANCEL_HEADER_DESCRIPTION_4;
  userFromMyClientView: boolean = false;

  constructor(private agreementService: AgreementService, public dialog: MatDialog,
              public dialogRef: MatDialogRef<OneClickEnrollCancelComponent>,
              public parentDialogRef: MatDialogRef<OneClickEnrollComponent>, @Inject(MAT_DIALOG_DATA) public data: any, log: LogService,
              private translate: PershingTranslationService,
               @Optional() @Inject('AppSettings') appSettings: any) {
    this.log = log;
    if (appSettings.ibdConfigMap) {
        this.userFromMyClientView = !!appSettings.isAdvisor ? appSettings.isAdvisor : false;
    }
    // log.info(data.email);
    // this.emails = data.emails;
    if (data) {
      this.parentDialogRef = data;
    }
    if (this.translate) {
      this.translate.addTranslationFolder('@pershing/edc-edelivery', 'node_modules/@pershing/edc-edelivery/lib');
    }
  }

  ngOnInit() {
    // console.log('current emails: ', this.emails);
  }

  ngOnDestroy() {
  }

  oneClickEnroll(): void  {
    this.dialogRef.close();
    // this.dialog.open(OneClickEnrollComponent, {data: { emails }, panelClass: ['modal', 'edel-AddEmail']});
  }

  close() {
    if (this.userFromMyClientView) {
     this.parentDialogRef.close();
     this.dialogRef.close();
     return;
    }
    this.agreementService.remindMeLaterAgreement();
    this.parentDialogRef.close();
    this.dialogRef.close();
  }
}
